import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { PriceToIncomeRatioRecord } from './usePriceToIncomeRatioData';
import { Place } from '@/types';

interface PeerPriceToIncomeRatioData {
  [key: string]: PriceToIncomeRatioRecord[]; // key is place_fips
}

export function usePeerPriceToIncomeRatioData(peers: Place[]) {
  const [data, setData] = useState<PeerPriceToIncomeRatioData>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!peers.length) {
      setLoading(false);
      setData({});
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    // Create an array of promises for each peer
    const fetchPromises = peers.map(peer => 
      supabase
        .from('acs_bps_metrics_housing_affordability')
        .select('*')
        .eq('Place', peer.name)
        .eq('place_fips', peer.place_fips)
        .order('year', { ascending: false })
    );

    Promise.all(fetchPromises)
      .then(results => {
        const newData: PeerPriceToIncomeRatioData = {};
        let loggedAny = false;
        results.forEach((result, index) => {
          if (result.error) {
            console.error(`Error fetching data for peer ${peers[index].name}:`, result.error);
          } else {
            const peerData = result.data || [];
            newData[peers[index].place_fips] = peerData;

            // Log the price-to-income ratio data for this peer
            const latestData = peerData[0];
            if (latestData) {
              loggedAny = true;
              console.log(`Peer City: ${peers[index].name}`);
              console.log(`  FIPS: ${peers[index].place_fips}`);
              console.log(`  Price to Income Ratio: ${latestData.price_to_income?.toFixed(2)}`);
              console.log(`  Year: ${latestData.year}`);
            }
          }
        });
        if (loggedAny) {
          console.log('------------------------');
        }
        setData(newData);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching peer price to income ratio data:', err);
        setError('Failed to fetch peer data');
        setLoading(false);
      });
  }, [peers]);

  return { data, loading, error };
} 